import { render, staticRenderFns } from "./ModalTransfereMatricula.vue?vue&type=template&id=438b2fdc"
import script from "./ModalTransfereMatricula.vue?vue&type=script&lang=js"
export * from "./ModalTransfereMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports